import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { requestVideoKeys } from '../api/keys';
import { fetchVideoUnits } from '../api/requestVideoApi';
import { STALE_TIME } from '../utils/constants';
import { toVideoUnit } from '../utils/unit';

export const useVideoUnits = ({ search, enabled = true }) => {
  const query = useInfiniteQuery({
    queryKey: requestVideoKeys.units(search),
    queryFn: ({ pageParam }) => fetchVideoUnits({ search, offset: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => lastPage.nextOffset,
    staleTime: STALE_TIME.units,
    enabled,
  });

  const units = useMemo(() => {
    const seen = new Set();
    const result = [];
    (query.data?.pages || []).forEach((page) => {
      page.items.forEach((item) => {
        if (seen.has(item.linkedDevice.id)) return;
        seen.add(item.linkedDevice.id);
        result.push(toVideoUnit(item));
      });
    });
    return result;
  }, [query.data]);

  return {
    units,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    hasNextPage: Boolean(query.hasNextPage),
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
    refetch: query.refetch,
  };
};
